import { actions as simpleActions } from '../slice';

import * as vehiclesListActions from './vehiclesListActions';
import * as vehicleUpsertActions from './vehicleUpsertActions';

export const actions = { ...simpleActions, ...vehiclesListActions, ...vehicleUpsertActions };
